import { hasuraClient } from './graphqlClient';
import { MAIL_NOTIFICATION_MUTATION } from '../graphql/mutations/notifications';

export const sendEmailNotification = async ({ recipient, templateName, templateData, subject }) => {
  try {
    const result = await hasuraClient.mutate(MAIL_NOTIFICATION_MUTATION, {
      input: {
        recipient,
        templateName,
        templateData,
        subject,
      },
    });

    return {
      success: true,
      data: result.mailNotification,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || 'Email notification failed',
    };
  }
};

export const sendWelcomeEmail = async (userData) => {
  const templateData = JSON.stringify({
    email: userData.email,
    password: userData.password,
    firstName: userData.firstName,
    lastName: userData.lastName,
  });

  return await sendEmailNotification({
    recipient: userData.email,
    templateName: 'welcome',
    templateData,
    subject: 'Hoşgeldiniz!!',
  });
}; 